// Registers the 'google-translate' component type so GrapesJS can render a
// placeholder in the editor. No scripts are injected into the canvas — actual
// translation is handled at publish time via initializeGoogleTranslate().
export default function googleTranslatePlugin(editor, options = {}) {
  editor.DomComponents.addType('google-translate', {
    model: {
      defaults: {
        tagName: 'div',
        attributes: {
          id: 'google_translate_element',
          class: 'google-translate-widget'
        },
        style: {
          margin: '10px 0',
          padding: '10px',
          'border-radius': '4px',
          'background-color': '#f8f9fa',
          border: '1px solid #e9ecef',
          'min-height': '40px',
          'text-align': 'center'
        },
        traits: [
          {
            type: 'select',
            name: 'layout',
            label: 'Layout',
            options: [
              { value: 'SIMPLE', name: 'Simple' },
              { value: 'VERTICAL', name: 'Vertical' },
              { value: 'HORIZONTAL', name: 'Horizontal' }
            ]
          },
          {
            type: 'text',
            name: 'included-languages',
            label: 'Languages (comma-separated)',
            placeholder: 'en,es,fr,de,it,pt,zh,ja,ko,ar,ru,hi'
          }
        ],
        droppable: false,
        copyable: true,
        removable: true,
        draggable: true,
        stylable: ['background-color', 'border', 'border-radius', 'padding', 'margin', 'width', 'height']
      }
    },

    view: {
      onRender() {
        this.el.innerHTML = `
          <div style="display:flex;align-items:center;justify-content:center;gap:8px;color:#666;font-size:14px;padding:10px;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 0 1 6.412 9m6.088 9h7M11 18l1.9-5.7a1.11 1.11 0 0 1 2.1 0L17 18m-1.5-3h-2"/>
            </svg>
            <span>Google Translate Widget (active on published site)</span>
          </div>
        `
      }
    }
  })
}

// Call this in the published site's HTML to activate Google Translate.
// The backend publish flow injects this when the agent has the translate block on any page.
export function initializeGoogleTranslate(config = {}) {
  const {
    pageLanguage = 'auto',
    includedLanguages = 'en,es,fr,de,it,pt,zh,ja,ko,ar,ru,hi',
    layout = 'SIMPLE',
    autoDisplay = false
  } = config

  window.googleTranslateElementInit = function () {
    new google.translate.TranslateElement(
      { pageLanguage, includedLanguages, layout: google.translate.TranslateElement.InlineLayout[layout], autoDisplay },
      'google_translate_element'
    )
  }

  const script = document.createElement('script')
  script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
  document.head.appendChild(script)
}
